import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
//Import Custom Services Here
import { SchoolGroupService } from "../report-services/school-group.service";
import { GradeLevelService } from "../report-services/grade-level.service";
import { GroupService } from "../report-services/group.service";
import { HomeroomService } from "../report-services/homeroom.service";

@Component({
	templateUrl: "./entryalertbycontainer.component.html",
})
export class EntryAlertbyContainerComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private groupService: GroupService,
		private homeroomService: HomeroomService,
		private gradelevelService: GradeLevelService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private schoolgroupService: SchoolGroupService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		SchoolGroupID: 0,
		PriorityID: "1",
		GradeLevelID: 0,
		GroupID: 0,
		HomeroomID: 0,
		ORDERBYID: "Infraction",
		ImageLogo: "",
		UserID: 0,
	};
	//Insert Custom Lists Here
	SchoolGroupList: any = [];
	GradeLevelList: any = [];
	GroupList: any = [];
	HomeroomList: any = [];
	ImageLogoList: any = [];
	schoolList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	PriorityList = [
		//Insert Custom List Items Here
		{
			PriorityID: "1",
			PriorityName: "1",
		},
		{
			PriorityID: "2",
			PriorityName: "2",
		},
		{
			PriorityID: "3",
			PriorityName: "3",
		},
		{
			PriorityID: "4",
			PriorityName: "4",
		},
		{
			PriorityID: "5",
			PriorityName: "5",
		},
	];

	ORDERBYList = [
		//Insert Custom List Items Here
		{
			ORDERBYID: "Infraction",
			ORDERBYName: "Infraction",
		},
		{
			ORDERBYID: "Name",
			ORDERBYName: "Name",
		},
		{
			ORDERBYID: "Penalty",
			ORDERBYName: "Penalty",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 392;
	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadSchoolGroupList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadSchoolGroupList();
		this.loadGradeLevelList();
		this.loadHomeroomList();
		this.loadGroupList();
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(392);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
					this.onSchoolChange(this.schoolList[0].SchoolID);
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadSchoolGroupList() {
		this.report.SchoolGroupID = 0;
		var result = this.schoolgroupService.loadSchoolGroupList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.SchoolGroupList = response;

				if (this.SchoolGroupList.length > 1) {
					// this.SchoolGroupList.unshift({
					//     SchoolGroupID: 0,
					//     SchoolGroupDesc: "All School Groups"
					// })
					this.report.SchoolGroupID = this.SchoolGroupList[0].SchoolGroupID;
				} else {
					this.report.SchoolGroupID = this.SchoolGroupList[0].SchoolGroupID;
				}
			},
			(error) => {}
		);
	}

	private loadGradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.gradelevelService.loadGradeLevelList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				if (this.GradeLevelList.length > 1) {
					// this.GradeLevelList.unshift({
					//     GradeLevelID: 0,
					//     GradeLevelDesc: "All GradeLevels"
					// })
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				} else {
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private loadHomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.homeroomService.loadHomeroomList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.HomeroomList = response;

				if (this.HomeroomList.length > 1) {
					// this.HomeroomList.unshift({
					//     HomeroomId: 0,
					//     HomeRoom: "All Homerooms"
					// })
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				} else {
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				}
			},
			(error) => {}
		);
	}

	private loadGroupList() {
		this.report.GroupID = 0;
		var result = this.groupService.loadGroupList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GroupList = response;

				if (this.GroupList.length > 1) {
					// this.GroupList.unshift({
					//     GroupID: 0,
					//     GroupName: "All Groups"
					// })
					this.report.GroupID = this.GroupList[0].GroupID;
				} else {
					this.report.GroupID = this.GroupList[0].GroupID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.SchoolGroupID) {
		// 	this.errorMessage = "Select the SchoolGroup"
		// 	return;
		// }

		// if (!this.report.PriorityID) {
		// 	this.errorMessage = "Select the Priority"
		// 	return;
		// }

		// if (!this.report.ORDERBYID) {
		// 	this.errorMessage = "Select the ORDERBY"
		// 	return;
		// }

		// if (!this.report.UserID) {
		// 	this.errorMessage = "Select the User"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 392;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolGroupID
		strParam += this.report.SchoolGroupID + "|SchoolGroupID";

		//Parameter 2: Priority
		strParam += "," + this.report.PriorityID + "|Priority";

		//Parameter 3: ORDERBY
		strParam += "," + this.report.ORDERBYID + "|OrderBy";

		//Parameter 4: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		//Parameter 5: UserID
		strParam += "," + this.report.UserID + "|UserID";

		//Parameter 6: GradeLevelID
		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";

		//Parameter 7: GroupID
		strParam += "," + this.report.GroupID + "|GroupID";

		//Parameter 8: HomeroomID
		strParam += "," + this.report.HomeroomID + "|HomeroomID";

		//strParam += "," + this.report.SchoolID + "|SchoolID";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
